// deck.gl-community
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import distance from '@turf/distance';
import ellipse from '@turf/ellipse';
import bearing from '@turf/bearing';
import { point } from '@turf/helpers';
import { getIntermediatePosition } from "./geojson-edit-mode.js";
import { ThreeClickPolygonMode } from "./three-click-polygon-mode.js";
export class DrawEllipseUsingThreePointsMode extends ThreeClickPolygonMode {
    getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
        const centerCoordinates = getIntermediatePosition(coord1, coord2);
        const xSemiAxis = Math.max(distance(centerCoordinates, point(coord3)), 0.001);
        const ySemiAxis = Math.max(distance(coord1, coord2), 0.001) / 2;
        const options = { angle: bearing(coord1, coord2) };
        // @ts-expect-error fix return types
        return ellipse(centerCoordinates, xSemiAxis, ySemiAxis, options);
    }
}
